export default "72 hours Duty 08:00 - 08:00<br />\nDate: 2nd of March";